"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.type = void 0;
/// <reference lib="DOM" />
exports.type = 'blob';
const fetchable = (url, timeout) => __awaiter(void 0, void 0, void 0, function* () {
    const controller = typeof AbortController !== "undefined" ? new AbortController() : {};
    const out = setTimeout(() => controller.abort && controller.abort(), timeout);
    //appending a query parameter to the image url to avoid the CORS error caused due to the browser cache issue
    url = url + "?export=epub";
    try {
        const res = yield fetch(url, { signal: controller.signal });
        if (!res.ok)
            throw new Error(`Got error ${res.status} (${res.statusText}) while fetching ${url}`);
        return res.blob();
    }
    finally {
        clearTimeout(out);
    }
});
exports.default = fetchable;
